var isdisable;
isdisable=true;
export const navigation = [

  
  {
    text: 'Student Portal',
    icon: 'm-menu__link-icon flaticon-tabs flaticon-color-change',
    items: [
     /*  {
        text: 'Dashboard ',
        path: '/studentportal/dashboard',
        icon: 'm-menu__link-icon flaticon-placeholder-1 flaticon-color-change'
      },
      {
        text: 'Student Profile',
        path: '/studentportal/profileprevious',
       // path: '/studentportal/studentProfile',
        icon: 'm-menu__link-icon flaticon-placeholder-1 flaticon-color-change'
      }, */
     /*  {
        text: 'Update Previous Marks',
        path: '/studentportal/update-marks',
        icon: 'm-menu__link-icon flaticon-placeholder-1 flaticon-color-change'
      }, */
     /*  {
        text: 'Bank Details',
        path: '/studentportal/bankDetails',
        icon: 'm-menu__link-icon flaticon-placeholder-1 flaticon-color-change'
      },
      {
        text: 'Sports & Hobby',
        path: '/studentportal/sportsHobby',
        icon: 'm-menu__link-icon flaticon-placeholder-1 flaticon-color-change'
      }, */

     
      /* {
        text: 'Exam Forms Approval',
        path: '/studentportal/examformsAproval',
        icon: 'm-menu__link-icon flaticon-line-graph flaticon-color-change'
      }, */
      // {
      //   text: 'Student Result',
      //   path: '/studentportal/studentresults',
      //   icon: 'm-menu__link-icon flaticon-placeholder-1 flaticon-color-change'
      // },
      /* {
        text: 'Apply For College',
        //text: 'Apply For Program',
        path: '/studentportal/admissionform',
        icon: 'm-menu__link-icon flaticon-placeholder-1 flaticon-color-change'
      },
      {
        text: 'Exam Forms',
        path: '/studentportal/examform',
        icon: 'm-menu__link-icon flaticon-line-graph flaticon-color-change'
      }, */
      /* {
        text: 'Exam Form Payment',
        path: '/studentportal/examformpaymentlist',
        icon: 'm-menu__link-icon flaticon-line-graph flaticon-color-change'
      }, */
      {
        text: 'Admission Form Payment',
        path: '/studentportal/admissionformpaymentlist',
        icon: 'm-menu__link-icon flaticon-line-graph flaticon-color-change'
      }, 
      {
        text: 'Change Password',
        path: '/studentportal/changepassword',
        icon: 'm-menu__link-icon flaticon-placeholder-1 flaticon-color-change'
      },
      /* {
        text: 'Hall Ticket',
        path: '/studentportal/hall-ticket',
        icon: 'm-menu__link-icon flaticon-placeholder-1 flaticon-color-change'
      }, */
     

    ]
  },

 
  //comment on 19/04/2019
   {  
    text: 'Request',
    disabled:false,
    icon: 'm-menu__link-icon flaticon-tabs flaticon-color-change',
    items: [
      {
        text: 'Request',
        path: '/changerequest/request',
        icon: 'm-menu__link-icon flaticon-line-graph flaticon-color-change'
      },
      /* {
        text: 'Specialization  Change',
        path: '/changerequest/branchchangeform',
        icon: 'm-menu__link-icon flaticon-line-graph flaticon-color-change'
      },
      {
        text: 'College Change',
        path: '/changerequest/collegechangeform',
        icon: 'm-menu__link-icon flaticon-line-graph flaticon-color-change'
      },
      {
        text: 'Center Change',
        path: '/changerequest/centerchange',
        icon: 'm-menu__link-icon flaticon-line-graph flaticon-color-change'
      },
      {
        text: 'Name Change',
        path: '/changerequest/namechangeform',
        icon: 'm-menu__link-icon flaticon-line-graph flaticon-color-change'
      },
      {
        text: 'Course Change',
        path: '/changerequest/subjectchange',
        icon: 'm-menu__link-icon flaticon-line-graph flaticon-color-change'
      }, */
    ]
  },
  /* {  
    text: 'Revaluation',
    disabled:true,
    icon: 'm-menu__link-icon flaticon-tabs flaticon-color-change',
    items: [
      {
        text: 'Photocopy Application',
        path: '',
        icon: 'm-menu__link-icon flaticon-line-graph flaticon-color-change'
      },
      {
        text: 'Revaluation Application',
        path: '',
        icon: 'm-menu__link-icon flaticon-line-graph flaticon-color-change'
      },
      {
        text: 'Verification Application',
        path: '',
        icon: 'm-menu__link-icon flaticon-line-graph flaticon-color-change'
      },

    ]
  },
  {  
    text: 'Certificate',
    disabled:true,
    icon: 'm-menu__link-icon flaticon-tabs flaticon-color-change',
    items: [
      {
        text: 'Duplicate Marksheet',
        path: '',
        icon: 'm-menu__link-icon flaticon-line-graph flaticon-color-change'
      },
      {
        text: 'Migration Application',
        path: '',
        icon: 'm-menu__link-icon flaticon-line-graph flaticon-color-change'
      },
      {
        text: 'Passing Certificate',
        path: '',
        icon: 'm-menu__link-icon flaticon-line-graph flaticon-color-change'
      },
      {
        text: 'Provision Marksheet',
        path: '',
        icon: 'm-menu__link-icon flaticon-line-graph flaticon-color-change'
      },
      {
        text: 'Special Certificate',
        path: '',
        icon: 'm-menu__link-icon flaticon-line-graph flaticon-color-change'
      },

    ]
  },
  {  
    text: 'Convocation',
    disabled:true,
    icon: 'm-menu__link-icon flaticon-tabs flaticon-color-change',
    items: [
      {
        text: 'Convocation Application',
        path: '',
        icon: 'm-menu__link-icon flaticon-line-graph flaticon-color-change'
      },
      
    ]
  }, */
/*   {
    text: 'Learning Management',
    path: 'linkingmanagement',
    icon: 'm-menu__link-icon flaticon-line-graph flaticon-color-change'
  },
  {
    text: 'Library',
    path: 'liabraryalink',
    icon: 'm-menu__link-icon flaticon-line-graph flaticon-color-change'
  },
  {
    text: 'Grievances',
    path: 'grievances',
    icon: 'm-menu__link-icon flaticon-line-graph flaticon-color-change'
  },
  {
    text: ' Academic Calender',
    path: 'academiccalender',
    icon: 'm-menu__link-icon flaticon-line-graph flaticon-color-change'
  },
  {
    text: 'Hostel Booking',
    path: 'hostelbooking',
    icon: 'm-menu__link-icon flaticon-line-graph flaticon-color-change'
  },
  {
    text: 'Alumni',
    path: 'alumnilink',
    icon: 'm-menu__link-icon flaticon-line-graph flaticon-color-change'
  },
 */

  /*
  {
    text: ' Registration',
    icon: 'm-menu__link-icon flaticon-line-graph flaticon-color-change',
    items: [
      {
        text: 'Manage Tahsil',
        path: '/registration/tahsillist',
        icon: 'm-menu__link-icon flaticon-placeholder-1 flaticon-color-change'
      }
    ]
  },*/


  // {
  //   text: 'Manage Venue Bookings',
  //   icon: 'm-menu__link-icon flaticon-tabs flaticon-color-change',
  //   items: [
  //     {
  //       text: 'Profile',
  //       path: '/profile1',
  //       icon:'m-menu__link-icon flaticon-line-graph flaticon-color-change'
  //     },
  //     {
  //       text: 'Display Data',
  //       path: '/display-data',
  //       icon:'m-menu__link-icon flaticon-share flaticon-color-change'
  //     }
  //   ]
  // }
];
